import React from "react";
import CoreButtonHoverIcon from "../../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { t } from "i18next";
import FolderSpecialRoundedIcon from "@mui/icons-material/FolderSpecialRounded";

const FoldersButtonCockpit = ({ onRefecthDocuments, onOpenModal }) => {
  return (
    <div className="flex w-full items-center">
      <CoreButtonHoverIcon
        onClick={onRefecthDocuments}
        className="text-blue-500 m-1 flex flex-row space-x-2 border"
        icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
        testo={t("Refresh")}
      />
      <CoreButtonHoverIcon
        onClick={onOpenModal}
        className="text-orange-500 m-1 flex flex-row space-x-2 border"
        icon={<FolderSpecialRoundedIcon className={`fill-orange-500`} />}
        testo={"Custom"}
      />
    </div>
  );
};

export default FoldersButtonCockpit;
